module.exports = __webpack_public_path__ + "img/MOD.4f33f9b7.svg";